import React, { FC } from 'react'
import ModalCore from 'react-overlays/Modal'
import styled from 'styled-components'

import { backdrop, box, smoothScroll } from '@Globals/Style/mixins'

import { Dialog, DialogProps } from './Dialog'
import { Fade } from './Fade'

const Wrapper = styled.div`
  position: fixed;
  z-index: ${({ theme }) => theme.zIndexes.globalOverlay};
  overflow: auto;
  top: 0;
  left: 0;
  ${smoothScroll}
  ${box({ width: '100%' })}
  transition: opacity 0.15s ease-out;
  overflow-y: scroll;
`

const Backdrop = styled.div`
  ${backdrop}
`

export type SharedModalProps = {
  ID?: string | null
  isOpen?: boolean
  onHide?: () => void
  onSubmit?: () => void
}

export interface ModalProps extends DialogProps, SharedModalProps {
  className?: string
  easyClose?: boolean
}

export const Modal: FC<ModalProps> = ({
  className,
  easyClose = true,
  isOpen = false,
  onHide,
  ...props
}) => (
  <ModalCore
    backdropTransition={Fade}
    className={className}
    onBackdropClick={() => easyClose && onHide && onHide()}
    onEscapeKeyDown={() => easyClose && onHide && onHide()}
    onHide={onHide}
    renderBackdrop={renderProps => <Backdrop {...renderProps} />}
    renderDialog={
      // The modelWrapper blocks clicking events from reaching the backdrop so it should handle
      // closing the modal itself
      renderProps => (
        <Wrapper {...renderProps} onClick={() => easyClose && onHide && onHide()}>
          <Dialog {...props} onHide={onHide} />
        </Wrapper>
      )
    }
    show={isOpen}
    transition={Fade}
  />
)
